export default "__VITE_ASSET__WSLwnkrL__"